"use strict";
var subscribeOn_1 = require('../operators/subscribeOn');
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return subscribeOn_1.subscribeOn(scheduler, delay)(this);
}
exports.subscribeOn = subscribeOn;
//# sourceMappingURL=subscribeOn.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/~/rxjs/operator/subscribeOn.js
// module id = ../../../../rxjs/operator/subscribeOn.js
// module chunks = 3